(function () {
    'use strict';

    angular
        .module('partners')
        .controller('PartnerModalController', PartnerModalController)

    PartnerModalController.$inject = ['$uibModalInstance', 'partner'];

    function PartnerModalController($uibModalInstance, partner) {
        var vm = this;

        vm.ok      = ok;
        vm.cancel  = cancel;
        vm.partner = partner;

        activate();


        function activate() {
        }


        function ok () {
            $uibModalInstance.close();
        }


        function cancel () {
            $uibModalInstance.close();
        }

    }

})();